const audios = {
  state: {
    //音频控件是否显示
    audioshow:false,
    audioIndex:0,
    music: '',
    MList:'',
    playing:true,


  },
  mutations: {
    showAudio(state) {
      state.audioshow = true;
    },
    hideAudio(state) {
      state.audioshow = false;
    },
    isPlay(state) {
      document.getElementById("audio").play();
    },
    isPause(state) {
      document.getElementById("audio").pause();
    },
  },
  actions: {
    showAudio:({commit})=>{
      commit("showAudio")
    },
    hideAudio:({commit})=>{
      commit("hideAudio")
    },
    isPlay:({commit})=>{
      commit("isPlay");
      commit("showAudio");
    },
    isPause:({commit})=>{
      commit("isPause");
      commit("hideAudio");
    },
  }
}

export default

  audios





// WEBPACK FOOTER //
// ./src/store/modules/audio.js